import { useStyletron } from "baseui";
import React, { useContext } from "react";
import { Callout, InlineCode, Paragraph } from "../markdown-components";
import { CalloutButton } from "../markdown-components/Callout";
import { DocsContext } from "./DocsContext";
import { desiredDocsVersion, isMismatchedVersionToCurrentApp } from "./nav/DocsVersionSelector";
import { useDocsLocation } from "./nav/useDocsLocation";

export const MismatchedDocsVersionBanner = () => {
  const [css, $theme] = useStyletron();
  const [location] = useDocsLocation();
  const { currentApp } = useContext(DocsContext);
  if (!isMismatchedVersionToCurrentApp(location, currentApp)) return null;
  const appVersion = desiredDocsVersion();

  return (
    <Callout type="warning" $style={{ marginTop: $theme.sizing.scale900 }}>
      <Paragraph>
        These docs are for a different version of Gadget than what the <InlineCode>{currentApp.slug}</InlineCode> app is using.
        <br />
        <br />
        <CalloutButton $as="a" href={appVersion.rootURL}>
          Switch to the correct version
        </CalloutButton>
      </Paragraph>
    </Callout>
  );
};
